/*
 * @Author: your name
 * @Date: 2021-03-17 15:38:04
 * @LastEditTime: 2021-10-19 15:02:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\uploadCenter.js
 */
// 导入中心
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  COMMON_MODULE_BASE_FILE_PROCESSOR_WEB = "",
  E6_MS_TMS_PERSONALIZE_WEB = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleBaseDataApi;
// 获取上传中心模块初始化数据
export function getUploadCenterInitInfo(params) {
  return http({
    url: `${host}${COMMON_MODULE_BASE_FILE_PROCESSOR_WEB}/importCenter/import/getTemplate`,
    method: "get",
    params
  });
}
// 导入解析数据
export function importAnalysisResult(url, data) {
  return http({
    url: `${host}/${url}`,
    method: "post",
    data
  });
}
// 订单导入模板获取
export function getExportTemplate(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/tms/excel/template/exportExcel`,
    method: "post",
    data
  });
}
// 获取费用设置枚举
export function fetchFeeSettingType() {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/getContractRuleImportType`,
    method: "get"
  });
}
// 获取计费规则导入模板
export function getFeeRuleImportTemplate(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/contractRule/getContractRuleImportTemplate`,
    method: "post",
    data
  });
}
